export default "<p>base-component works!</p>\r\n"